import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const industries = [
  { name: 'Retail & E-commerce', icon: '🛒' },
  { name: 'FMCG & Distribution', icon: '📦' },
  { name: 'Manufacturing & Industrial', icon: '🏭' },
  { name: 'Hospitality', icon: '🏨' },
  { name: 'Corporate Offices', icon: '🏢' },
  { name: 'Warehousing & Logistics', icon: '🚛' },
  { name: 'Healthcare & Pharma', icon: '💊' },
  { name: 'IT Parks', icon: '💻' },
  { name: 'Corporate Parks', icon: '🏗️' },
  { name: 'Factories', icon: '⚙️' },
];

const clients = [
  'Campa Cola', 'Reliance Retail', 'Reliance Brands', 'DTDC',
  'Reliance Digital', 'Hamleys',
];

export function Industries() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section ref={ref} className="py-20 lg:py-28 bg-slate-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className="mb-12"
        >
          <p className="text-xs font-semibold tracking-widest uppercase text-gray-400 mb-4">
            Industries We Serve
          </p>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900">
            Tailored for every sector.
          </h2>
        </motion.div>

        {/* Industry pills */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="flex flex-wrap gap-3 mb-14"
        >
          {industries.map((industry) => (
            <span
              key={industry.name}
              className="flex items-center gap-2 px-5 py-2.5 border border-gray-200 rounded-full text-sm font-medium text-gray-700 hover:border-p-600 hover:text-p-600 hover:bg-p-50 transition-all cursor-default"
            >
              <span>{industry.icon}</span>
              {industry.name}
            </span>
          ))}
        </motion.div>

        {/* Clients we serve */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="border-t border-gray-200 pt-10"
        >
          <p className="text-xs font-semibold tracking-widest uppercase text-gray-400 mb-6">
            Brands We Serve
          </p>
          <div className="flex flex-wrap gap-4">
            {clients.map((client) => (
              <span
                key={client}
                className="px-6 py-2.5 bg-white border border-gray-200 rounded-full text-sm font-semibold text-gray-800 shadow-sm"
              >
                {client}
              </span>
            ))}
          </div>
        </motion.div>

        {/* Closing lines */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="mt-12"
        >
          <p className="text-xl lg:text-2xl italic text-gray-400 leading-snug">
            Each industry produces different waste streams.
          </p>
          <p className="text-xl lg:text-2xl italic text-gray-400 leading-snug">
            Our solutions adapt accordingly.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
